import { Button } from '@talentmesh/ui/components/button';
import { ButtonGroup } from '@talentmesh/ui/components/button-group';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@talentmesh/ui/components/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import useAISearchProgress from '../../../api/useAISearchProgress';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import RefineCriteriaDialog from './RefineCriteriaDialog';
import RefineFilterDialog from './RefineFilterDialog';
import UIStrings from '@/Utils/UIStrings';

export const disableAutoOpenRefineSearchDialogKey = 'disableAutoOpenRefineSearchDialog';

const RefineSearchButton = () => {
    const [criteriaOpen, setCriteriaOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const { data: progressData, isLoading: isProgressDataLoading } = useAISearchProgress();
    const { isRefineSearchFiltersReady, isRefineSearchCriteriaReady } = useIdentifiedListContext();
    const isAiSearching = isProgressDataLoading || progressData?.isInProgress;

    return (
        <>
            <ButtonGroup>
                <Button
                    variant="default"
                    disabled={isAiSearching || !isRefineSearchCriteriaReady}
                    onClick={() => setCriteriaOpen(true)}
                >
                    {UIStrings.RefineCriteria}
                </Button>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button
                            variant="default"
                            size="icon"
                            disabled={isAiSearching || !isRefineSearchFiltersReady}
                            aria-label={UIStrings.RefineSearchMoreOptions}
                        >
                            <ChevronDown />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                        <DropdownMenuItem onSelect={() => setFilterOpen(true)}>
                            {UIStrings.RefineFilter}
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </ButtonGroup>
            <RefineCriteriaDialog open={criteriaOpen} onOpenChange={setCriteriaOpen} />
            <RefineFilterDialog open={filterOpen} onOpenChange={setFilterOpen} />
        </>
    );
};

export default RefineSearchButton;
